import { defineFeature } from "../core/composition/define-feature.js";
import { deriveSharedMinStartMediaTime, establishStartMediaTime } from "../behaviors/establish-start-media-time.js";
import { relocationPipelinesFor } from "../playback/primitives/relocation-pipelines.js";
//#region src/playback/features/shift-timestamps.ts
/** The behaviors the feature composes, in setup order. */
const behaviors = [establishStartMediaTime];
/** The config defaults the feature contributes. */
const defaultConfig = {
	deriveStartMediaTime: deriveSharedMinStartMediaTime,
	videoMessagePipelines: relocationPipelinesFor("video"),
	audioMessagePipelines: relocationPipelinesFor("audio")
};
/** The state values the feature seeds. */
const initialState = {};
/**
* Plays HLS content whose segment timestamps don't start at zero, by shifting them onto the playlist's zero-based
* timeline. Without it, such content strands the playhead outside the buffered ranges; content that starts at zero
* doesn't need it. Text cues shift with `shiftTextTimestampsFeature`, composed alongside it and `textTracksFeature`.
*/
const shiftTimestampsFeature = defineFeature({
	behaviors,
	defaultConfig,
	initialState
});
//#endregion
export { behaviors, defaultConfig, initialState, shiftTimestampsFeature };
